import { getUserProperties } from '@thoughtspot/session-service';
export function buildPathWithParams(path, urlQueryParams) {
    if (!urlQueryParams?.length)
        return path;
    const searchParams = new URLSearchParams();
    urlQueryParams.forEach(({ name, value }) => {
        searchParams.set(name, String(value));
    });
    return `${path}?${searchParams.toString()}`;
}
export function getSavedOnboardingSelections(functionOptions, industryOptions, isMTService, savedRole) {
    const userProperties = getUserProperties();
    const savedFunction = isMTService
        ? savedRole?.function
        : userProperties?.function;
    const savedIndustry = isMTService
        ? savedRole?.industry
        : userProperties?.industry;
    return {
        function: savedFunction &&
            functionOptions.some(opt => opt.id === savedFunction)
            ? savedFunction
            : '',
        industry: savedIndustry &&
            industryOptions.some(opt => opt.id === savedIndustry)
            ? savedIndustry
            : '',
    };
}
//# sourceMappingURL=utils.js.map